module.exports = __webpack_public_path__ + "static/media/procurar.a9ff9867.svg";